import React from 'react'

import { Box, Typography } from '@mui/material'

import { theme } from 'styles/theme'

import * as S from './styles'
type ItemProps = {
  textKey: string
  value: string | React.ReactNode
}
const Item = ({ textKey, value }: ItemProps) => {
  const largeFields = ['Observações', 'Descrição']
  // Campos cujo valor é uma lista (vários anexos): o rótulo alinha no topo, e o valor
  // recebe a largura que sobra em vez de ficar espremido no canto (SC-10805).
  const listFields = ['Arquivos anexados']
  const isList = listFields.includes(textKey)

  return (
    <Box
      sx={{
        ...(largeFields.includes(textKey)
          ? { margin: '10px 0px 10px 0px' }
          : {
              display: 'flex',
              gap: 1.25,
              alignItems: isList ? 'start' : 'end',
              margin: '10px 0px 10px 0px'
            })
      }}
    >
      <Typography
        variant="smLight"
        color={theme.palette.neutral[400]}
        whiteSpace="nowrap"
      >
        {textKey}
        {largeFields.includes(textKey) ? ':' : ' '}
      </Typography>
      {!largeFields.includes(textKey) && (
        <S.Separator
          sx={{
            marginTop: '4px',
            // Numa lista o pontilhado cede a largura para o nome do arquivo, em vez de
            // crescer e empurrar o texto para o canto (SC-10805).
            ...(isList ? { flexGrow: 0, flexShrink: 1, flexBasis: '24px' } : {})
          }}
        />
      )}
      <Typography
        variant="smBold"
        display="flex"
        alignItems="center"
        sx={isList ? { flex: 1, minWidth: 0 } : undefined}
      >
        {value}
      </Typography>
    </Box>
  )
}

export default Item
